module.exports = __webpack_public_path__ + "img/bone.d0b1b567.png";